import { createFileRoute } from '@tanstack/react-router'
import MarketingCampanhasSegmentadasPage from '@/pages/dashboard/marketing-campanhas-segmentadas-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/',
)({
  component: function MarketingCampanhasIndexRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.MARKETING} dashboardId={dashboardId}>
        <MarketingCampanhasSegmentadasPage />
      </RequireModule>
    )
  },
})
